import React, { Component } from 'react';
import {connect} from 'react-redux';
import Loader from "react-loader-spinner";
import { AiOutlineWarning } from 'react-icons/ai';
import { FiInfo } from "react-icons/fi";
import * as formActions from '../../Redux/Actions/form';
import * as jobActions from '../../Redux/Actions/jobs';
import * as userAuthActions from '../../Redux/Actions/user';
import { toastMessage } from '../utils/toast';
import { getParams } from '../utils';
import { Button } from '../Ui/Button';
import { Input, TextArea } from '../Ui/Input';
import Radio from '../Ui/Radio';
import DropDown from '../Ui/DropDown';
import Upload from '../Ui/Upload';
import Checkbox from '../Ui/Checkbox';
import Map from '../Ui/Map';
import { DisplayServiceCard } from '../CreateForm/ServiceCard/displayServiceCard';
import { DocumentVaultModal, DocumentUploadModal } from '../PreviewForm/documentModal';
import { MapModal } from '../PreviewForm/mapModal';
import { ContainerOuter, LoaderContainer, ContainerInner, DataContainer } from '../PreviewForm/styles';
import { formValidation } from '../utils/formValidation';
import AamerLoader from '../Ui/Loader';
import CONFIG from '../../config';

class EditPreviewForm extends Component {

    state = {
        loading: false,
        data: {},
        params: {},
        fieldsData: [],
        feedBack: '',
        jobID:'',
        jobStatus:'',
        editableFields: [],
        buttonLoading: false,
        documentVaultLabel: '',
        documentVaultData: [],
        documentVaultModal: false,
        documentVaultModalLoading: false,
        documentFromVault: false,
        documentUploadModal: false,
        documentUploadLoading: false,
        documentUploadData: {},
        existingDocLoading: false,
        mapValueLabel: '',
        mapModal: false,
        mapModalLoading: false,
    };

    componentDidMount(){
        let params = getParams(window.location.search);
        this.getIndividualForm(params.formID);
        this.setState({ params });
    }

    getIndividualForm = (formID) => {
        this.setState({loading: true});
        const { history, userAuthLogout, match } = this.props;
        const {jobID} = match.params;
        this.setState({jobID})
        formActions.getIndividualForm(formID).then(res => {
            if(res && res.data){
                let data = res.data[0];
                this.setState({
                    data,
                    fieldsData: JSON.parse(data.json)
                }, this.getIndividualJob(jobID, JSON.parse(data.json).formFields));
            }
        }).catch(err => {
            toastMessage('error', 'Unable to load the form');
            this.setState({loading: false});
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    getObjectFormFieldsFormatData = ({ data }) => {
        let newData = {};
        for (const [key, value] of Object.entries(data)) {
            let fieldName = key.split(/\+/);
            newData[(key.includes('+') ? fieldName[1] : key)] = value;
        }
        return newData;
    }

    getIndividualJob = (jobID, fieldsData) => {
        const { history, userAuthLogout } = this.props;
        const { params } = this.state;
        jobActions.get(jobID).then(res => {
            if(CONFIG.isSlackBotEnable === true){
                let text = `name: Update - Form Started\ntime:${Date()}\nuserID:${params.userID}\nformID:${params.formID}\njobID:${jobID}\nfieldName:\ntimeDifference:`;
                let payload = {text: text};
                formActions.slackBOT(payload).then();
            }
            if(res && res.data && res.data.jobInfo){
                let jobStatus = res.data.jobInfo.status;
                let editableFields = (res.data.jobInfo && res.data.jobInfo.editableFields) ? res.data.jobInfo.editableFields : [];
                let data = JSON.parse(res.data.jobInfo.json);
                let formFieldsData = this.getObjectFormFieldsFormatData(data);
                this.setState({
                    jobStatus,
                    editableFields,
                    feedBack: res.data.feedBack
                });
                fieldsData = fieldsData && fieldsData.map(({name, type}) => ({  name: name && name.replace(/ /g, '').toLowerCase(), type}));
                for (const field of fieldsData) {
                    if (field.name) {
                        let fieldName = field.name.split(/\+/);
                        this.setState({
                            [(field.name.includes('+') ? fieldName[1] : field.name)]: formFieldsData[(field.name.includes('+') ? fieldName[1] : field.name)]
                        });
                        if(field.type === 'upload') {
                            this.setState({ existingDocLoading: true });
                            let existingDocs = {};
                            for (const [key, value] of Object.entries(data.documents)) {
                                let name = key.split(/\+/)
                                existingDocs = {[(key.includes('+') ? name[1] : key)] : value, ...existingDocs}
                            }
                            formActions.getDocumentMetaData(params.userID, existingDocs[field.name]).then(res => {
                                let documentFileName = (res.data && res.data.length > 1) ? `${res.data.length} files selected` : res.data[0].fileName;
                                this.setState({
                                    [field.name]: existingDocs[field.name],
                                    [field.name+'File']: res.data,
                                    [field.name+'Name']: documentFileName
                                });
                            }).catch(err => {
                                this.setState({
                                    existingDocLoading: false
                                });
                                console.log('Unable to get documents meta data');
                            });
                        }
                    }
                }
                setTimeout(() => {
                    this.setState({
                        existingDocLoading: false
                    });
                }, 8000);
            }
            this.setState({loading: false});
        }).catch(err => {
            toastMessage('error', 'Unable to get the job details');
            this.setState({loading: false});
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleInputChange = (key, value) => {
        let keyName = key.replace(/ /g, '').toLowerCase();
        (keyName === 'userinfo') && this.handleCheckedDefaultUserInfo(value);
        this.setState({
            [keyName]: value
        });
    }

    handleCheckedDefaultUserInfo = (value) => {
        let defaultuserinfoemail = '', defaultuserinfophonenumber = '';
        const { params } = this.state;
        if (value) {
            defaultuserinfoemail = params.email;
            defaultuserinfophonenumber = params.phonenumber;
        }
        this.setState({
            defaultuserinfoemail, defaultuserinfophonenumber
        });
    }

    handleMultiCheckbox = (label, key) => {
        let oldData = this.state[label] ? this.state[label] : [];
        this.setState({
            [label]: oldData.includes(key) ? oldData.filter(value => value !== key) : [...oldData, key]
        });
    }

    handleUploadModal = (name, files, category, limit) => {
        if(isNaN(limit) || (files.length <= limit)){
            this.setState({
                documentUploadData: {label: name.replace(/ /g, '').toLowerCase(), files, category, limit},
                documentUploadModal: true,
                [name+'Err']: ''
            });
        }else{
            this.setState({[name+'Err']: `You can select upto ${limit} files only`});
        }
    }

    handleUploadDocument = (modalData) => {
        let jID = this.props.match.params;
        const { documentUploadData, params } = this.state;
        const { history, userAuthLogout } = this.props;
        this.setState({ documentUploadLoading: true });

        let uploadStartTime = new Date();
        if(CONFIG.isSlackBotEnable === true){
            let uploadStartText = `name: Update - Upload file start\ntime:${uploadStartTime}\nuserID:${params.userID}\nformID:${params.formID}\njobID:${jID.jobID}\nfieldName:${documentUploadData.label}\ndocumentIDs:\ntimeDifference:`;
            let payload = {text: uploadStartText};
            formActions.slackBOT(payload).then();
        }
        
        let data = new FormData();
        data.append('userId', params.userID);
        documentUploadData.category && documentUploadData.category.value && data.append('tag', documentUploadData.category.value);
        for(let i=0; i <= documentUploadData.files.length; i++) {
            if(modalData['name'+(i+1)] !== undefined) {
                data.append('files', documentUploadData.files[i]);
                data.append('fileNames', modalData['name'+(i+1)] + '.' + modalData['extension'+(i+1)]);
                data.append('extensions', '.' + modalData['extension'+(i+1)]);
            }
        }
        
        let keyName = documentUploadData.label;
        formActions.uploadMultipleDocument(data).then(res => {
            if(res && res.data){
                if(CONFIG.isSlackBotEnable === true){
                    let uploadEndTime = new Date();
                    let timeDif = (uploadEndTime.getTime() - uploadStartTime.getTime())/1000;
                    let uploadEndText = `name: Update - Upload file end\ntime:${Date()}\nuserID:${params.userID}\nformID:${params.formID}\njobID:${jID.jobID}\nfieldName:${documentUploadData.label}\ndocumentIDs:${res.data}\ntimeDifference:${timeDif} s`;
                    let payload = {text: uploadEndText};
                    formActions.slackBOT(payload).then();
                }
                
                this.setState({
                    documentUploadModal: false,
                    documentFromVault: false,
                    documentUploadLoading: false,
                    [keyName]: res.data,
                    [keyName+'Name']: (documentUploadData.files.length === 1) ? modalData['name1'] : `${documentUploadData.files.length} files selected`
                });
            }else{
                toastMessage('error', (res && res.message));
            }
        }).catch(err => {
            toastMessage('error', 'Unable to upload the documents');
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleDocumentVault = (name) => {
        const { params } = this.state;
        const { history, userAuthLogout } = this.props;
        this.setState({documentVaultModal: true, documentVaultModalLoading: true, [name+'Err']: ''});
        let keyName = name.replace(/ /g, '').toLowerCase();
        formActions.listUserDocuments(params.userID).then(res => {
            if(res && res.data){
                this.setState({documentVaultModalLoading: false, documentVaultData: res.data, documentVaultLabel: keyName});
            }
        }).catch(err => {
            toastMessage('error', 'Unable to load the documents');
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleReloadDocumentVault = () => {
        this.setState({documentVaultModal: true, documentVaultModalLoading: true});
        const { params } = this.state;
        const { history, userAuthLogout } = this.props;
        formActions.listUserDocuments(params.userID).then(res => {
            if(res && res.data){
                this.setState({ documentVaultModalLoading: false, documentVaultData: res.data });
            }
        }).catch(err => {
            toastMessage('error', 'Unable to load the documents');
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleDocumentID = (documentId, fileName) => {
        const {documentVaultLabel} = this.state;
        this.setState({documentVaultModal: false, [documentVaultLabel]: documentId, [documentVaultLabel+'Name']: fileName, documentFromVault: true});
    }

    handleRemoveDocument = (name, documentID) => {
        const { params } = this.state;
        let keyName = name.replace(/ /g, '').toLowerCase();
        formActions.removeDocument(params.userID, documentID).then(res => {
            this.setState({ [keyName+'Name']: '', [keyName]: '', documentUploadData: {} });
            window.location.reload();
            toastMessage('success', (res && res.message) || `Successfully deleted the document`);
        }).catch(err => {
            console.log('Something Went Wrong', err);
        });
    }

    handleLoadMap = (name) => {
        this.setState({mapModal: true, mapModalLoading: true, [name+'Err']: '', mapValueLabel: name.replace(/ /g, '').toLowerCase()});
    }

    handleSetCoordinates = (value) => {
        const {mapValueLabel} = this.state;
        this.setState({
            mapModal: false,
            [mapValueLabel]: value
        });
    }

    handleMapValueChange = (value, name) => {
        let keyName = name.replace(/ /g, '').toLowerCase();
        this.setState({
            [keyName]: {...this.state[keyName], address: value}
        });
    }

    handleUpdateJob = (actionLabel) => {
        const { history, userAuthLogout } = this.props;
        const { params } = this.state;
        this.setState({ ['buttonLoading'+actionLabel]: true });

        let { fieldsData, data: formWholeData, jobID, jobStatus } = this.state;
        fieldsData = fieldsData.formFields && fieldsData.formFields.map(({name, type, englishlabel, arabiclabel, required}) => 
            ({type, englishlabel, arabiclabel, required, name: name && name.replace(/ /g, '').toLowerCase()}));
        let data = {}, documents = {}, errCount = 0;
        if (actionLabel === 'saveasdraft') {
            for (const field of fieldsData) {
                if(field.type === 'upload') {
                    documents = {...documents, [field.name]: this.state[field.name]};
                    this.setState({[field.name+'Err']: ''})
                } else {
                    data = {...data, [field.name]: this.state[field.name]};
                }
            }
        } else {
            for (const field of fieldsData) {
                const response = formValidation(field.type, field.englishlabel, field.required, this.state[(field.type === 'upload') ? field.name : field.name]);
                errCount = response ? ++errCount : errCount;
                if(response){
                    response && this.setState({ ['buttonLoading'+actionLabel]: false });
                    this.setState({[field.name+'Err']: response});
                }else if(errCount === 0) {
                    if(field.type === 'upload') {
                        documents = {...documents, [field.englishlabel+'+'+field.name]: this.state[field.name]};
                        this.setState({[field.name+'Err']: ''});
                    } else {
                        data = {...data, [field.englishlabel+'+'+field.name]: this.state[field.name]};
                    }
                }
            }
        }
        if(errCount === 0) {
            let payload = {
                id: jobID, fromUserId: params.userID, processId: formWholeData.processId, formId: params.formID, json: JSON.stringify({data, documents})
            };
            let jobAction = (actionLabel === 'saveasdraft') ? 'DRAFT_EDIT' : ((jobStatus === 'Draft') ? 'DRAFT_SUBMIT' : 'JOB_EDIT');
            jobActions.update(payload, jobAction).then(res => {
                if(res && res.data){
                    history.push(`/submitted-form/${params.formID}`);
                }
                this.setState({ ['buttonLoading'+actionLabel]: true });
            }).catch(err => {
                toastMessage('error', 'Unable to update the form');
                if(err.response.status === 401) {
                    userAuthLogout();
                    localStorage.removeItem('jwt');
                    history.push('/');
                }
            });
        }
    }

    handleDisableField = (name) => {
        let fieldKey = name.replace(/ /g, '').toLowerCase();
        const { editableFields, jobStatus } = this.state;
        let disabledJobStatus = ('AwaitingResponse' === jobStatus);
        if (disabledJobStatus && (editableFields.length !== 0)) {
            let fieldKeyAvailable = editableFields.filter(({key}) => key === fieldKey)[0];
            return (fieldKeyAvailable && fieldKeyAvailable.isEditable) ? false : true;
        } else {
            return false;
        }
    }

    render(){
        const { data, feedBack, params, fieldsData, documentVaultModal, documentVaultData, documentFromVault, documentUploadModal, 
            documentUploadData, documentUploadLoading, documentVaultModalLoading, existingDocLoading, loading, mapModal, mapModalLoading, mapValueLabel
        } = this.state;
        let isArabic = (params.lang === 'ar');

        return(
            <>
                <ContainerOuter>
                    {(!(data && data.name) || existingDocLoading || loading) ? <LoaderContainer><AamerLoader /></LoaderContainer> : <ContainerInner>
                        {(fieldsData && fieldsData.formFields.length === 0) ? <p style={{textAlign: 'center'}}>No Data Available</p> : 
                            <>
                                <h3 className="text-center pt-16 pb-6">{isArabic ? data.arabicName : data.name}</h3>
                                {feedBack && <div className="p-3 mb-6" style={{border: '1px solid #f41d34', borderRadius: '5px'}}>
                                    <AiOutlineWarning className="m-auto text-danger d-flex font-size-h4" />
                                    <div className="text-danger mt-2" dangerouslySetInnerHTML={{__html: feedBack}} />
                                </div>}
                                {(fieldsData.serviceCards && fieldsData.serviceCards.length !== 0) && <DisplayServiceCard isArabic={isArabic} data={fieldsData.serviceCards} formID={params.formID} />}

                                {fieldsData.formFields.map(({
                                    type, name, method, characterlength, required, disabled, englishlabel, arabiclabel, label, placeholder, 
                                    options, multiple, dynamic, encrypt, documentvault, limit, category}, index) => (
                                    <DataContainer key={index} style={{background: 'none'}}>
                                        {(type === 'input') ? 
                                            <Input isArabic={isArabic} onChange={e => this.handleInputChange(name, e.target.value)} 
                                                value={this.state[name.replace(/ /g, '').toLowerCase()]} placeholder={placeholder} 
                                                maxLength={characterlength} method={method} encrypt={encrypt} label={englishlabel || label} 
                                                arabiclabel={arabiclabel} required={required}
                                                error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                disabled={this.handleDisableField(name)}
                                            />
                                            : (type === 'date') ? 
                                                <Input isArabic={isArabic} onChange={e => this.handleInputChange(name, e.target.value)} 
                                                    value={this.state[name.replace(/ /g, '').toLowerCase()]} 
                                                    label={englishlabel || label} arabiclabel={arabiclabel} method={'date'} required={required} 
                                                    placeholder={placeholder} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                    disabled={this.handleDisableField(name)}
                                                />
                                                : (type === 'checkbox') ? 
                                                    <Checkbox isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} 
                                                        required={required} 
                                                        options={options} value={this.state[name.replace(/ /g, '').toLowerCase()]} 
                                                        onChange={e => this.handleInputChange(name, e.target.checked)}
                                                        multiOnChange={this.handleMultiCheckbox} 
                                                        error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                        disabled={disabled || this.handleDisableField(name)} 
                                                    />
                                                    : (type === 'textarea') ? 
                                                        <TextArea isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} maxLength={characterlength}
                                                            value={this.state[name.replace(/ /g, '').toLowerCase()]} method={'text'} required={required} placeholder={placeholder} 
                                                            onChange={e => this.handleInputChange(name, e.target.value)} 
                                                            error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                            disabled={this.handleDisableField(name)}
                                                        />
                                                        : (type === 'radio') ? 
                                                            <Radio isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} 
                                                                options={options} value={this.state[name.replace(/ /g, '').toLowerCase()]} 
                                                                dynamic={dynamic} onChange={e => this.handleInputChange(name, e.target.value)} 
                                                                error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                                disabled={this.handleDisableField(name)}
                                                            />
                                                            : (type === 'dropdown') ? 
                                                                <DropDown isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} 
                                                                    required={required} editJob={true}
                                                                    value={this.state[name.replace(/ /g, '').toLowerCase()]} 
                                                                    options={options} dynamic={dynamic} placeholder={placeholder} 
                                                                    onChange={(value) => this.handleInputChange(name, value.value)} 
                                                                    error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                                    disabled={this.handleDisableField(name)}
                                                                />
                                                                : (type === 'upload') ? 
                                                                    <Upload loading={existingDocLoading} formID={params.formID} isArabic={isArabic} label={englishlabel || label} 
                                                                        arabiclabel={arabiclabel} required={required} multiple={multiple} placeholder={placeholder} name={name}
                                                                        documentvault={documentvault} documentFromVault={documentFromVault}
                                                                        onChange={e => this.handleUploadModal(name, e.target.files, category, parseInt(limit))}
                                                                        selectedFiles={this.state[name.replace(/ /g, '').toLowerCase()+'Name']} 
                                                                        selectedFilesContent={this.state[name.replace(/ /g, '').toLowerCase()]}
                                                                        previewFile={this.state[name.replace(/ /g, '').toLowerCase()+'File']}
                                                                        listDocument={() => this.handleDocumentVault(name)} 
                                                                        handleRemoveDocument={this.handleRemoveDocument}
                                                                        uploadFileErr={this.state[name+'Err']} 
                                                                        error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                                        disabled={this.handleDisableField(name)}
                                                                    />
                                                                    : (type === 'breakline') ? <hr className="section-divider" />
                                                                        : (type === 'disclaimer') ? 
                                                                            <span>
                                                                                <FiInfo style={{margin: '-5 0 0 0', color: '#121180', fontSize: '20px'}}/>
                                                                                <i>{isArabic? arabiclabel: englishlabel}</i>
                                                                            </span>
                                                                            : (type === 'map') ? 
                                                                                <Map formID={params.formID} isArabic={isArabic} label={englishlabel || label} 
                                                                                    arabiclabel={arabiclabel} required={required} placeholder={placeholder} 
                                                                                    onClick={e => this.handleLoadMap(name)} 
                                                                                    value={this.state[name.replace(/ /g, '').toLowerCase()]} 
                                                                                    error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']}
                                                                                    handleMapValueChange={e => this.handleMapValueChange(e.target.value, name)}
                                                                                />
                                                                                : ''}
                                    </DataContainer>
                                ))}
                                
                                {(fieldsData && fieldsData.actions && fieldsData && fieldsData.actions.length !== 0) && <div>
                                    <DataContainer className="m-3 mb-8" style={{margin: '8px 0', display: 'flex', justifyContent: 'center', background: 'none'}}>
                                        {fieldsData.actions.map(({actionLabel, actionName, arabicActionLabel, arabicActionName}) =>
                                            <Button disabled={this.state['buttonLoading'+actionLabel] || existingDocLoading || loading} 
                                                key={actionLabel} style={{marginRight: 8}} onClick={() => this.handleUpdateJob(actionLabel)}>
                                                {isArabic ? arabicActionName : actionName}
                                                {this.state['buttonLoading'+actionLabel] && <Loader type="Oval" color="#00BFFF" height={15} width={15} style={{marginLeft: '10px'}} />}
                                            </Button>
                                        )}
                                    </DataContainer>
                                </div>}
                            </>
                        }
                    </ContainerInner>}
                </ContainerOuter>
                {documentUploadModal && <DocumentUploadModal
                    title={'Upload Document'} showModal={documentUploadModal} loading={documentUploadLoading} data={documentUploadData} 
                    handleOk={this.handleUploadDocument} handleCancel={() => this.setState({documentUploadModal: false})} 
                />}
                {documentVaultModal && <DocumentVaultModal
                    title={'Select Document'} showModal={documentVaultModal} loading={documentVaultModalLoading} data={documentVaultData}
                    handleOk={this.handleDocumentID} handleCancel={() => this.setState({documentVaultModal: false})}
                    userID={params.userID} handleReloadDocumentVault={this.handleReloadDocumentVault}
                />}
                {mapModal && <MapModal showModal={mapModal} loading={mapModalLoading} value={this.state[mapValueLabel.replace(/ /g, '').toLowerCase()]} handleOk={this.handleSetCoordinates} handleCancel={() => this.setState({mapModal: false})} isArabic={isArabic} userID={params.userID} />}
            </>
        );
    };
};

const mapDispatchToProps = (dispatch) => ({
    userAuthLogout: () => dispatch(userAuthActions.userAuthLogout())
});

export default connect(null, mapDispatchToProps)(EditPreviewForm);